module.exports = __webpack_public_path__ + "img/mgmdialog.0256c566.png";